// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gfA4BvygM1mXK2 {
  display: flex;
  z-index: 2;
  flex-direction: column;
}
.gfA4BvygM1mXK2 .HIzUUSl_mlCMv8 {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: var(--ds-space-100, 8px);
}
.gfA4BvygM1mXK2 .HIzUUSl_mlCMv8 .W4U9_6TF0Qd8V_,
.gfA4BvygM1mXK2 .HIzUUSl_mlCMv8 .KrvmSqW5kDgs2t {
  border: none;
  border-radius: var(--ds-border-radius-100, 3px);
  background-color: unset;
  color: var(--ds-text-subtlest, #626f86);
  cursor: pointer;
}
.gfA4BvygM1mXK2 .HIzUUSl_mlCMv8 .W4U9_6TF0Qd8V_:hover,
.gfA4BvygM1mXK2 .HIzUUSl_mlCMv8 .KrvmSqW5kDgs2t:hover,
.gfA4BvygM1mXK2 .HIzUUSl_mlCMv8 .W4U9_6TF0Qd8V_:focus,
.gfA4BvygM1mXK2 .HIzUUSl_mlCMv8 .KrvmSqW5kDgs2t:focus,
.gfA4BvygM1mXK2 .HIzUUSl_mlCMv8 .W4U9_6TF0Qd8V_.FbPsA3vBIQabhF,
.gfA4BvygM1mXK2 .HIzUUSl_mlCMv8 .KrvmSqW5kDgs2t.FbPsA3vBIQabhF {
  background-color: var(--ds-background-neutral-hovered, #091e4224);
  color: var(--ds-text, #172b4d);
}
.gfA4BvygM1mXK2 .HIzUUSl_mlCMv8 .W4U9_6TF0Qd8V_ {
  margin-left: var(--ds-space-100, 8px);
}
.gfA4BvygM1mXK2 .HIzUUSl_mlCMv8 .KrvmSqW5kDgs2t {
  transform: rotate(180deg);
}
.gfA4BvygM1mXK2.GAOH4rdss3eu8e {
  position: absolute;
  bottom: var(--ds-space-300, 24px);
  left: var(--ds-space-300, 24px);
  width: 300px;
  padding: var(--ds-space-200, 16px) var(--ds-space-300, 24px) var(--ds-space-300, 24px) var(--ds-space-300, 24px);
  border: var(--ds-border-width, 1px) solid var(--ds-border, #091e4224);
  border-radius: var(--ds-border-radius, 4px);
  background-color: var(--ds-surface, #ffffff);
}
.gfA4BvygM1mXK2.GAOH4rdss3eu8e .l6t5HpG6UbkiAY {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.gfA4BvygM1mXK2.GAOH4rdss3eu8e .l6t5HpG6UbkiAY .B_nV6zfMRBWKPe {
  align-self: flex-end;
  width: max-content;
  background-color: var(--ds-surface, #ffffff);
}
.gfA4BvygM1mXK2.GAOH4rdss3eu8e .l6t5HpG6UbkiAY .B_nV6zfMRBWKPe:hover,
.gfA4BvygM1mXK2.GAOH4rdss3eu8e .l6t5HpG6UbkiAY .B_nV6zfMRBWKPe:focus,
.gfA4BvygM1mXK2.GAOH4rdss3eu8e .l6t5HpG6UbkiAY .B_nV6zfMRBWKPe:active {
  background-color: var(--ds-surface-hovered, #f1f2f4);
}
.gfA4BvygM1mXK2.GAOH4rdss3eu8e .HIzUUSl_mlCMv8 {
  flex-direction: column;
  align-items: flex-start;
  margin-left: unset;
}
.gfA4BvygM1mXK2.GAOH4rdss3eu8e .HIzUUSl_mlCMv8 .W4U9_6TF0Qd8V_ {
  margin-left: unset;
}
@media only screen and (max-width: 600px) {
  .gfA4BvygM1mXK2.GAOH4rdss3eu8e {
    bottom: var(--ds-space-0, 0px);
    left: var(--ds-space-0, 0px);
  }
}
`, ""]);
// Exports
export var feedbackCollectorContainer = `gfA4BvygM1mXK2`;
export var feedbackButtonsContainer = `HIzUUSl_mlCMv8`;
export var positiveFeedbackButton = `W4U9_6TF0Qd8V_`;
export var negativeFeedbackButton = `KrvmSqW5kDgs2t`;
export var selected = `FbPsA3vBIQabhF`;
export var flagTreatment = `GAOH4rdss3eu8e`;
export var titleAndCloseButton = `l6t5HpG6UbkiAY`;
export var closeButton = `B_nV6zfMRBWKPe`;
export default ___CSS_LOADER_EXPORT___;
